var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3417_8020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 8C11.1667 9.47276 9.97276 10.6667 8.5 10.6667C7.02724 10.6667 5.83333 9.47276 5.83333 8C5.83333 6.52724 7.02724 5.33333 8.5 5.33333C9.97276 5.33333 11.1667 6.52724 11.1667 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83333 0H9.16667V2.70793C11.5791 3.00876 13.4912 4.92086 13.7921 7.33333H16.5V8.66667H13.7921C13.4912 11.0791 11.5791 12.9912 9.16667 13.2921V16H7.83333V13.2921C5.42086 12.9912 3.50876 11.0791 3.20793 8.66667H0.5V7.33333H3.20793C3.50876 4.92086 5.42086 3.00876 7.83333 2.70793V0ZM8.5 12C10.7091 12 12.5 10.2091 12.5 8C12.5 5.79086 10.7091 4 8.5 4C6.29086 4 4.5 5.79086 4.5 8C4.5 10.2091 6.29086 12 8.5 12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3417_8020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current_location.f6967995b24fe6b63bc00ba5b9897e70.svg";
export { ForwardRef as ReactComponent };